import { styled } from '@clickcease/cc-client-components-lib'

export const PlanFeaturesTableStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '1120px',

  '@bp1': {
    width: '100%',
    alignItems: 'center',
  },
})

export const MobileHeaderStyled = styled('div', {
  background:
    'linear-gradient(180deg, rgba(136, 179, 231, 0.00) 0%, rgba(136, 179, 231, 0.20) 100%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})

export const FeaturesContainerStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',

  '@bp1': {
    paddingTop: '$12',
  },
})
